import { render, staticRenderFns } from "./newRole.vue?vue&type=template&id=64b7d782&scoped=true"
import script from "./newRole.vue?vue&type=script&lang=js"
export * from "./newRole.vue?vue&type=script&lang=js"
import style0 from "./newRole.vue?vue&type=style&index=0&id=64b7d782&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b7d782",
  null
  
)

export default component.exports